import { TileSetMapType, CHARACTER_DIRECTION } from "common/model";

export const WALL = 23;
export const FLOOR = 14;
export const CHAR = 1;
export const BOX = 15;
export const GOAL = 11;

export const buildMap = (
  layer1: number[][],
  layer2: number[][],
  direction: CHARACTER_DIRECTION = CHARACTER_DIRECTION.CHARACTER_DIRECTION_X,
): TileSetMapType => ({
  character: { direction },
  landscape: [layer1, layer2],
});
